import { firestore } from 'firebase';
import { enumerateDaysBetweenDates } from '@/utils/misc';

function formatTimeWindows(timeWindowDetails = {}) {
  return {
    for_date: timeWindowDetails.date,
    last_updated:
      timeWindowDetails.last_updated && timeWindowDetails.last_updated.seconds,
    time_windows: timeWindowDetails.times || [],
  };
}

/* eslint-disable import/prefer-default-export */
export async function fetchTimeWindows(storeDocumentRef, startDate, endDate) {
  const moment = require('moment');

  const startRangeId = `${moment(startDate).format('YYYY')}_${moment(startDate).format('W')}`;

  const endRangeId = `${moment(endDate).format('YYYY')}_${moment(endDate).format('W')}`;

  const response = await storeDocumentRef
    .collection('time_windows')
    .where(firestore.FieldPath.documentId(), '>=', startRangeId)
    .where(firestore.FieldPath.documentId(), '<=', endRangeId)
    .get();

  const days = response.docs.reduce((allDays, week) => {
    const weekData = week.data();
    delete weekData.week;
    delete weekData.year;
    return { ...weekData, ...allDays };
  }, {});

  return enumerateDaysBetweenDates(startDate, endDate).map((date) => {
    const timeWindows = days[`available_times_${date.replaceAll('-', '_')}`] || null;
    return formatTimeWindows({ date, ...timeWindows });
  });
}
